import React, { ComponentType } from 'react'
import style from './style/TPAPreloaderOverlay.scss'
import type { TPAWidgetBeckyProps } from '@wix/thunderbolt-components'

type TPAPreloaderOverlayProps = {
	translations: TPAWidgetBeckyProps['translations']
	isEditor: boolean
	appDefinitionName: string
	getParentHeight: () => number
}

const TPAPreloaderOverlay: ComponentType<TPAPreloaderOverlayProps> = ({
	translations,
	isEditor,
	appDefinitionName,
	getParentHeight,
}) => {
	const {
		preloaderOverlay: { loading },
	} = translations

	return (
		<div className={isEditor ? style.editorContent : style.content}>
			<div className={isEditor ? style.editorPreloader : style.circlePreloader} />
			{isEditor && (
				<span style={{ lineHeight: `${getParentHeight()}px` }}>
					{loading} {appDefinitionName || ''} ...
				</span>
			)}
		</div>
	)
}

export default TPAPreloaderOverlay
